import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { io } from "socket.io-client";
import {
  setAudioChannel,
  setRemoteChannelMutes,
} from "../../utils/gameAudio";
import { isAdminAppPath } from "../../utils/publicAccessPaths";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001";

const applyMutePayload = (payload) => {
  if (!payload) return;
  setRemoteChannelMutes({
    userMuted: !!payload.userMuted,
    adminMuted: !!payload.adminMuted,
  });
};

/**
 * Keeps game audio aware of the current page (admin vs user) and
 * venue-wide mute switches from Sound System.
 */
const GameSoundChannelMuteSync = () => {
  const location = useLocation();

  useEffect(() => {
    setAudioChannel(isAdminAppPath(location.pathname) ? "admin" : "user");
  }, [location.pathname]);

  useEffect(() => {
    let cancelled = false;

    fetch(`${API_BASE}/api/game-sounds/mute`)
      .then((r) => r.json())
      .then((data) => {
        if (cancelled || !data?.success) return;
        applyMutePayload(data);
      })
      .catch(() => {});

    const socket = io(API_BASE, {
      transports: ["websocket", "polling"],
      withCredentials: true,
    });
    socket.on("game_sounds:mute", applyMutePayload);

    return () => {
      cancelled = true;
      socket.off("game_sounds:mute", applyMutePayload);
      socket.disconnect();
    };
  }, []);

  return null;
};

export default GameSoundChannelMuteSync;
